/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notetaker_Issue_Too_Little_Said_BodyInputs */



/**
* | output |
* | --- |
* | "The meeting was over before enough was recorded to write a report." |
*
* @param {Meeting_Notetaker_Issue_Too_Little_Said_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_too_little_said_body = /** @type {((inputs?: Meeting_Notetaker_Issue_Too_Little_Said_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_Too_Little_Said_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("De meeting was voorbij voor er genoeg opgenomen was om een verslag van te maken.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("La réunion était terminée avant que suffisamment soit enregistré pour en faire un compte rendu.")
	return /** @type {LocalizedString} */ ("The meeting was over before enough was recorded to write a report.")
});